




import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import SortIcon from "@/shared/components/SortIcon.vue";
import {
  ManagedExpensesSortableColumns,
  SortOrder
} from "@/shared/types";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";

@Component({
  components: { SortIcon }
})
export default class ManagedExpenseColumnSortIcon extends Vue {
  managedExpensesStore = useManagedExpenseStore();

  @Prop({ required: true })
  managedExpenseColumn: ManagedExpensesSortableColumns;

  get isSortedByColumn () {
    return this.managedExpensesStore.currentPage.sortByColumn === this.managedExpenseColumn;
  }

  get sortOrder () {
    if (this.isSortedByColumn) {
      return this.managedExpensesStore.currentPage.sortOrder;
    }
    return SortOrder.None;
  }
}
